import { render, staticRenderFns } from "./SpiderStats.vue?vue&type=template&id=04dec22a&scoped=true&"
import script from "./SpiderStats.vue?vue&type=script&lang=js&"
export * from "./SpiderStats.vue?vue&type=script&lang=js&"
import style0 from "./SpiderStats.vue?vue&type=style&index=0&id=04dec22a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dec22a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04dec22a')) {
      api.createRecord('04dec22a', component.options)
    } else {
      api.reload('04dec22a', component.options)
    }
    module.hot.accept("./SpiderStats.vue?vue&type=template&id=04dec22a&scoped=true&", function () {
      api.rerender('04dec22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stats/SpiderStats.vue"
export default component.exports